import {
    FETCH_STATUS_REPORT_DATA_START,
    FETCH_STATUS_REPORT_DATA_SUCCESS,
    FETCH_STATUS_REPORT_DATA_FAIL
} from "../../../constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { FETCH_STATUS_REPORT } from "../../../../../config/constants";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';


export const fetchStatusReport = (payload, cb) => {
    const apiBaseInstance = new ApiBase();
    return (dispatch) => {
        dispatch(withType(FETCH_STATUS_REPORT_DATA_START, {}));
        apiBaseInstance.instance
            .post(FETCH_STATUS_REPORT, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then((response) => {
                dispatch(
                    withType(FETCH_STATUS_REPORT_DATA_SUCCESS, {
                        data: response.data,
                    })
                );
                cb && cb();
            })
            .catch((err) => {
                dispatch(
                    withType(FETCH_STATUS_REPORT_DATA_FAIL, {
                        error: err,
                    })
                );
            });
    };
}